<template>
  <div>
    <transition name="fade">
      <div
        class="fixed top-0 left-0 right-0 bottom-0 bg-white"
        v-show="show"
        @click="handleTick"
        v-if="this.menu.screensaver_url"
      >
        <img
          v-if="mediaType === 'image'"
          :src="this.menu.screensaver_url"
          class="h-full w-full object-cover"
        />
        <video
          v-else
          :key="video"
          class="h-full w-full object-cover"
          autoplay="true"
          muted="true"
          loop="true"
        >
          <source
            id="source"
            :src="this.menu.screensaver_url"
            type="video/mp4"
          />
        </video>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { clickTypeEvents, filetypeByUrl } from "../utils";
export default {
  data() {
    return {
      show: false,
      timer: undefined,
      mediaType: undefined,
      video: "test",
    };
  },
  props: {
    src: String,
    format: String,
    type: {
      validator: function (value) {
        return ["image", "video"].indexOf(value) !== -1;
      },
    },
  },
  mounted() {
    this.$store.dispatch("GET_MENU_ITEMS").then(() => {
      this.startTimer();
    })
    this.video = this.menu.screensaver_url;
    const self = this;
    this.computeType();
    if (this.hasKiosk)
      clickTypeEvents.forEach((eventType) => {
        document
          .querySelector("#timeOutClickable")
          .addEventListener(eventType, self.handleTick);
      });
  },
  updated() {
    this.video = this.menu.screensaver_url;
  },
  methods: {
    changeVideo() {
      this.video = this.src;
    },
    startTimer() {
      if (this.timer) clearTimeout(this.timer);
      const self = this;
      const seconds = process.env.NODE_ENV === "development" ? (this.screensaverTime != 'undefined' ? this.screensaverTime : 15) : 15;
      this.timer = setTimeout(() => {
        self.show = true;
      }, seconds * 1000);
    },
    handleTick() {
      this.show = false;
      this.startTimer();
    },
    async computeType() {
      const t = await filetypeByUrl(this.menu.screensaver_url);
      this.mediaType = await t;
    },
  },
  computed: {
    ...mapGetters(["menu"]),
     ...mapGetters("Theme", [
      "screensaverTime",
      "orderTypeButtonShadow"
    ]),
  },
  watch: {
    "menu.screensaver_url": function () {
      this.computeType();
    },  
  },
};
</script>
<style></style>
